import {
  withImageEmbed,
} from '@udecode/plate';

import { withImageUpload } from '../upload/withImageUpload';

export const withImage = (
  editor,
  plugin,
) => {
  let _editor = editor;
  const {
    options: { disableUploadInsert, disableEmbedInsert },
  } = plugin;
  if (!disableUploadInsert) {
    _editor = withImageUpload(editor, plugin);
  }

  if (!disableEmbedInsert) {
    _editor = withImageEmbed(editor, plugin);
  }
  return _editor;
};